const Main = () => import ('../views/main/main.vue')
const doctFlowIndex = () => import ('@/views/xtgl/doctFlowIndex')
const comForm = () => import ( '@/views/xtgl/comForm')
const comView = () => import ('@/views/xtgl/comView')
const userIndex = () => import ( '@/views/xtgl/userIndex')
const userForm = () => import ('@/views/xtgl/userForm')
const dacIndex = () => import ('@/views/xtgl/dacIndex')
const dacForm = () => import ('@/views/xtgl/dacForm')
const userRoleForm = () => import ('@/views/xtgl/userRoleForm')
const dsIndex = () => import ('@/views/xtgl/dsIndex')
const dstableForm = () => import ( '@/views/xtgl/dstableForm')
const dsfieldForm = () => import ( '@/views/xtgl/dsfieldForm')
const reportIndex = () => import ( '@/views/xtgl/reportIndex')
const dptarea = () => import ( '@/views/xtgl/dptarea')
const rfieldForm = () => import ('@/views/xtgl/rfieldForm')
const docthIndex = () => import ('@/views/common/docthIndex')
const docgenForm = () => import ( '@/views/common/docgenForm')
const index = () => import ( '@/views/login/index')
const mainIndex = () => import ( '@/views/main/mainIndex')
const dptIndex = () => import ('@/views/xtgl/dptIndex')
const dptfrom = () => import ( '@/views/xtgl/dptfrom')
const changeStatus = () => import ('@/views/xtgl/changeStatus')
const changeStatusFrom = () => import ('@/views/xtgl/changeStatusFrom')

export default [{
  path: '/xtgl',
  component: Main,
  redirect: '',
  meta: {
    title: '系统管理',
    icon: 'guide'
  },
  children: [
    {
      path: 'doctFlowIndex',
      component: doctFlowIndex,
      name: 'doctFlowIndex',
      meta: { title: '单据审核流程', keepAlive: true }
    },
    {
      path: 'comForm',
      component: comForm,
      name: 'comForm',
      meta: { title: '编辑单位资料', keepAlive: true }
    },
    {
      path: 'comView',
      component: comView,
      name: 'comView',
      meta: { title: '查看单位资料', keepAlive: true }
    },
    {
      path: 'dptIndex',
      component: dptIndex,
      name: 'dptIndex',
      meta: { title: '部门资料', keepAlive: true }
    },
    {
      path: 'userIndex',
      component: userIndex,
      name: 'userIndex',
      meta: { title: '用户管理', keepAlive: true }
    },
    {
      path: 'userForm',
      component: userForm,
      name: 'userForm',
      meta: { title: '用户维护', keepAlive: true }
    },
    {
      path: 'dacIndex',
      component: dacIndex,
      name: 'dacIndex',
      meta: { title: '数据权限', keepAlive: true }
    },
    {
      path: 'dacForm',
      component: dacForm,
      name: 'dacForm',
      meta: { title: '数据权限', keepAlive: true }
    },
    {
      path: 'userRoleForm',
      component: userRoleForm,
      name: 'userRoleForm',
      meta: { title: '配置角色', keepAlive: true }
    },
    {
      path: 'dsIndex',
      component: dsIndex,
      name: 'dsIndex',
      meta: { title: '报表数据源', keepAlive: true }
    },
    {
      path: 'dstableForm',
      component: dstableForm,
      name: 'dstableForm',
      meta: { title: '数据源表', keepAlive: true }
    },
    {
      path: 'dsfieldForm',
      component: dsfieldForm,
      name: 'dsfieldForm',
      meta: { title: '数据源字段清单', keepAlive: true }
    },
    {
      path: 'reportIndex',
      component: reportIndex,
      name: 'reportIndex',
      meta: { title: '报表管理', keepAlive: true }
    },
    {
      path: 'rfieldForm',
      component: rfieldForm,
      name: 'rfieldForm',
      meta: { title: '报表字段', keepAlive: true }
    },
    {
      path: 'docthIndex',
      component: docthIndex, 
      name: 'docthIndex',
      meta: { title: '单据审核记录', keepAlive: true }
    },
    {
      path: 'docgenForm',
      component: docgenForm,
      name: 'docgenForm',
      meta: { title: '单据生成', keepAlive: true }
    },
    {
      path: 'dptarea',
      component: dptarea,
      name: 'dptarea',
      meta: { title: '地区管理', keepAlive: true }
    },
    {
      path: 'dptfrom',
      component: dptfrom,
      name: 'dptfrom',
      meta: { title: '部门管理', keepAlive: true }
    },
    {
      path: 'changeStatus',
      component: changeStatus,
      name: 'changeStatus',
      meta: { title: '状态管理清单', keepAlive: true }
    },
    {
      path: 'changeStatusFrom',
      component: changeStatusFrom,
      name: 'changeStatusFrom',
      meta: { title: '状态管理', keepAlive: true }
    }
  ]
},
{ path: '/login', component: index, hidden: true },
{
  path: '',
  redirect: '',
  component: Main,
  children: [
    {
      path: 'mainIndex',
      component: mainIndex,
      name: 'mainIndex',
      meta: { title: '首页',  keepAlive: true }
    }
  ]
}]
